<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<div *ngIf="!vm.loading">
		<div class="c-content c-content--border-bottom u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--wrap">
				<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('created')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Claim.Created' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='created' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='created' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<!-- div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('treatmentPlace')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Claim.Treatment_Place' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='treatmentPlace' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='treatmentPlace' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div-->
				<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('policyNumber')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Insurance.Policy.Policy_Number' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='policyNumber' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='policyNumber' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-50 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray c-text--right" (click)="vm.setFilter('treatmentDescription')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Claim_Request.Case_Description' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='treatmentDescription' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='treatmentDescription' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
			</div>
		</div>
		<ul class="c-list">
			<li *ngFor="let claimItem of vm.claimsList | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
				<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
					<div class="o-grid o-grid--wrap@up-to-md">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Claim.Created' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ claimItem.created | date:'dd.MM.yyyy HH:mm' }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--s10 u-hidden@up-to-md">
								{{ claimItem.created | date:'dd.MM.yyyy HH:mm' }}
							</p>
						</div>
						<!-- div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Claim.Treatment_Place' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ claimItem.treatmentPlace }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--s10 u-hidden@up-to-md">
								{{ claimItem.treatmentPlace }}
							</p>
						</div-->
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Insurance.Policy.Policy_Number' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p *ngIf="!claimItem.policyUser.policy.externalPolicyDownloadUrl" class="c-text c-text--sm@up-to-md">
										{{ claimItem.policyUser.policy.policyNumber }}
									</p>
									<a *ngIf="claimItem.policyUser.policy.externalPolicyDownloadUrl" href="{{ claimItem.policyUser.policy.externalPolicyDownloadUrl }}" target="_blank" rel="noopener" class="c-text c-text--sm@up-to-md">
										{{ claimItem.policyUser.policy.policyNumber }}
									</a>
								</div>
							</div>
							<p *ngIf="!claimItem.policyUser.policy.externalPolicyDownloadUrl" class="c-text c-text--s10 u-hidden@up-to-md">
								{{ claimItem.policyUser.policy.policyNumber }}
							</p>
							<a *ngIf="claimItem.policyUser.policy.externalPolicyDownloadUrl" href="{{ claimItem.policyUser.policy.externalPolicyDownloadUrl }}" target="_blank" rel="noopener" class="c-text u-hidden@up-to-md">
								{{ claimItem.policyUser.policy.policyNumber }}
							</a>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Claim_Request.Case_Description' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p id="claimTreatmentDescription1_{{$index}}" class="c-text c-text--sm@up-to-md">{{ claimItem.treatmentDescription }}</p>
								</div>
							</div>
							<p id="claimTreatmentDescription2_{{$index}}" class="c-text c-text--s10 u-hidden@up-to-md">{{ claimItem.treatmentDescription }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o1@md-and-up u-ost-md@up-to-md">
							<p *ngIf="claimItem.status === 'INCOMPLETE' || claimItem.status === 'PENDING'" class="c-text c-text--right u-osr-xl@md-and-up">
								<a id="claimTreatmentEditButton_{{$index}}" [routerLink]="['/claim-request']" [queryParams]="{ claimId: claimItem.id }" class="c-text c-text--uppercase c-text--bold" (click)="vm.editClaim(claimItem)">
									{{ 'Modal.Title.Edit' | translate }}
								</a>
							</p>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<item-no-content *ngIf="!vm.claimsList?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
